import React from "react";

class AdditionalDetails extends React.Component {
		state = {
        dataset: []
    };
    componentDidMount(props)
   {
    let id = this.props.id;
        fetch(`http://localhost:8090/api/orders/${id}`)
            .then((response) => response.json())
            .then(data => {
                this.setState({ dataset: data });
            }); 
 }
	render(){
  return (
    <div>
	<div className="row">
{this.state.dataset.map((machine,i) => (
<div key={i} className="col-sm-12">
<div className="card">
<div className="card-header">
<h5>Additional Details</h5>
</div>
<div className="card-body">
<form id="validation-form123" action="">
<div className="row">
<div className="col-md-6">
<div className="form-group">
 <label className="form-label">CM Value</label>
<input type="text" className="form-control" defaultValue={machine.Cmk_values}/>
</div>
</div>
<div className="col-md-6">
<div className="form-group">
<label className="form-label">CPK Value</label>
<input type="text" className="form-control"/>
</div>
</div>
<div className="col-md-6">
<div className="form-group">
<label className="form-label">Master Equipment</label>
<input type="text" className="form-control" readOnly/>
</div>
</div>
<div className="col-md-6">
<div className="form-group">
<label className="form-label">Prority </label>
<input type="text" className="form-control" />
</div>
</div>


</div>
<button type="submit" className="btn  btn-primary mx-1">Save</button>
<button type="submit" className="btn  btn-primary mx-1">close</button>
<button type="submit" className="btn  btn-primary mx-1">Import Details</button>
<button type="submit" className="btn  btn-primary mx-1 my-1">characteristics</button>
</form>
</div>
</div>
</div>
))}
</div>
    </div>
  );
	}
}

export default AdditionalDetails;